export const contentModel = {
  event: 'event',
  events: 'events',
  document: 'document',
  news: 'news',
  page: 'page',
  socials: 'socials',
  action: 'action',
  actions: 'actions',
  labo: 'labo',
  project: 'project',
  dataOdre: 'datasOdre',
  presentation: 'presentation',
  profile: 'profile',
  governance: 'governance',
  hub: 'hub',
  map: 'map',
  newsroom: 'newsroom',
  contact: 'contact',
  home: 'home',
  homepage: 'homepage',
  medias: 'medias',
  doc: 'doc',
  press: 'press',
  video: 'video',
  front_img: 'front_img',
  testimony: 'testimony',
  blog: 'blog',
}
